import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { buildSeoBrandString } from 'helpers/SeoUrlBuilder';
import ProductUtils from 'helpers/ProductUtils';
import styles from 'styles/components/productdetail/productName.scss';

const ProductName = ({ product }, { testId }) => {
  const { brandName, brandId, productName, defaultProductType } = product;
  const isNotGiftCard = !ProductUtils.isGiftCard(defaultProductType);
  // We keep the space after the brand name for screen readers reading the brand then the product name.
  return (
    <h1 className={styles.container}>
      {isNotGiftCard && (<span
        className={styles.brandName}
        itemProp="brand"
        itemScope
        itemType="http://schema.org/Brand">
        <Link to={buildSeoBrandString(brandName, brandId)} itemProp="url" data-test-id={testId('pdpBrandName')}>
          <span itemProp="name">{brandName}</span>
        </Link>
        {' '}
      </span>)}
      <span className={styles.productName} itemProp="name" data-test-id={testId('pdpProductName')}>
        {productName}
      </span>
    </h1>
  );
};

ProductName.propTypes = {
  product: PropTypes.object.isRequired
};

ProductName.contextTypes = {
  testId: PropTypes.func
};

export default ProductName;
